import { render, staticRenderFns } from "./PackageDetailedView.vue?vue&type=template&id=b5dce57c&scoped=true"
import script from "./PackageDetailedView.vue?vue&type=script&lang=js"
export * from "./PackageDetailedView.vue?vue&type=script&lang=js"
import style0 from "./PackageDetailedView.vue?vue&type=style&index=0&id=b5dce57c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5dce57c",
  null
  
)

export default component.exports